<template>
    <div>
        <v-dialog v-model="show" max-width="1200px" persistent>
            <v-card>
                <v-card-title class="primary white--text">
                    <v-icon left color="white">mdi-file-edit-outline</v-icon>
                    {{
                        aguardandoReprocessamento
                            ? 'Editar e Reprocessar Retorno'
                            : 'Editar Falha de Retorno'
                    }}
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="fecharModal">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-6">
                    <Loading :active="loading" :is-full-page="false" />

                    <v-row>
                        <v-col cols="12">
                            <v-card outlined class="mb-4">
                                <v-card-title class="subtitle-1 primary--text">
                                    <v-icon left color="primary"
                                        >mdi-file-document</v-icon
                                    >
                                    INFORMAÇÕES DO TÍTULO
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" md="3">
                                            <v-text-field
                                                v-model="
                                                    dadosEdicao.cd_status_retorno
                                                "
                                                label="Código do Status"
                                                outlined
                                                dense
                                                class="editable-field"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-text-field
                                                v-model="dadosEdicao.id_titulo"
                                                label="ID"
                                                outlined
                                                dense
                                                readonly
                                                disabled
                                                class="readonly-field"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="
                                                    dadosEdicao.nosso_numero
                                                "
                                                label="Nosso Número"
                                                outlined
                                                dense
                                                readonly
                                                disabled
                                                class="readonly-field"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12">
                            <v-card outlined class="mb-4">
                                <v-card-title class="subtitle-1 warning--text">
                                    <v-icon left color="warning"
                                        >mdi-alert-circle</v-icon
                                    >
                                    CÓDIGO DE IRREGULARIDADE
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-textarea
                                                v-model="
                                                    dadosEdicao.problema_pendente
                                                "
                                                label="Pendência"
                                                outlined
                                                rows="3"
                                                class="editable-field"
                                            />
                                        </v-col>
                                        <v-col cols="12">
                                            <v-textarea
                                                v-model="
                                                    dadosEdicao.info_adicional
                                                "
                                                label="Informação Adicional"
                                                outlined
                                                rows="2"
                                                class="editable-field"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12">
                            <v-card outlined class="mb-4">
                                <v-card-title class="subtitle-1 orange--text">
                                    <v-icon left color="orange"
                                        >mdi-file-document-outline</v-icon
                                    >
                                    ARQUIVO DE RETORNO
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="
                                                    dadosEdicao.protocolo_recebido
                                                "
                                                label="Protocolo Recebido"
                                                outlined
                                                dense
                                                readonly
                                                disabled
                                                class="readonly-field"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="
                                                    dadosEdicao.cartorio_recebido
                                                "
                                                label="Cartório Recebido"
                                                outlined
                                                dense
                                                readonly
                                                disabled
                                                class="readonly-field"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="
                                                    dadosEdicao.dt_apontamento
                                                "
                                                label="Data do Apontamento"
                                                outlined
                                                dense
                                                readonly
                                                disabled
                                                class="readonly-field"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="
                                                    dadosEdicao.tp_ocorrencia_cartorio
                                                "
                                                label="Código do Status (Retorno)"
                                                outlined
                                                dense
                                                readonly
                                                disabled
                                                class="readonly-field"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12">
                            <v-card outlined class="mb-4">
                                <v-card-title class="subtitle-1 success--text">
                                    <v-icon left color="success"
                                        >mdi-map-marker</v-icon
                                    >
                                    APONTAMENTO
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="6" md="3">
                                            <v-text-field
                                                v-model="
                                                    dadosEdicao.protocolo_cartorio
                                                "
                                                label="Protocolo do Cartório"
                                                outlined
                                                dense
                                                class="editable-field"
                                            />
                                        </v-col>
                                        <v-col cols="6" md="3">
                                            <v-text-field
                                                v-model="
                                                    dadosEdicao.cartorio_titulo
                                                "
                                                label="Protocolo do Cartório"
                                                outlined
                                                dense
                                                class="editable-field"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="dadosEdicao.cartorio"
                                                label="Cartório"
                                                outlined
                                                dense
                                                disabled
                                                class="readonly-field"
                                            />
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                v-model="
                                                    dadosEdicao.endereco_cartorio
                                                "
                                                label="Endereço do Cartório"
                                                outlined
                                                dense
                                                disabled
                                                class="readonly-field"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                v-model="
                                                    dadosEdicao.titulo_dt_protocolo
                                                "
                                                label="Data do Apontamento"
                                                outlined
                                                dense
                                                type="date"
                                                class="editable-field"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                v-model="
                                                    dadosEdicao.municipio_apontamento
                                                "
                                                label="Município do Apontamento"
                                                outlined
                                                dense
                                                disabled
                                                class="readonly-field"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                v-model="
                                                    dadosEdicao.email_cartorio
                                                "
                                                label="E-mail do Cartório"
                                                outlined
                                                dense
                                                type="email"
                                                disabled
                                                class="readonly-field"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="
                                                    dadosEdicao.telefone_cartorio
                                                "
                                                label="Telefone do Cartório"
                                                outlined
                                                dense
                                                disabled
                                                class="readonly-field"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12">
                            <v-card outlined class="mb-4">
                                <v-card-title class="subtitle-1 info--text">
                                    <v-icon left color="info"
                                        >mdi-account-tie</v-icon
                                    >
                                    APRESENTANTE
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" md="8">
                                            <v-text-field
                                                v-model="
                                                    detalhesCompletos.razao_social_apresentante
                                                "
                                                label="Razão Social"
                                                outlined
                                                dense
                                                readonly
                                                disabled
                                                class="readonly-field"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                v-model="
                                                    dadosEdicao.cd_apresentante
                                                "
                                                label="Código"
                                                outlined
                                                dense
                                                readonly
                                                disabled
                                                class="readonly-field"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12">
                            <v-card outlined>
                                <v-card-title class="subtitle-1 purple--text">
                                    <v-icon left color="purple"
                                        >mdi-history</v-icon
                                    >
                                    HISTÓRICO DE STATUS
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="success"
                                        small
                                        @click="abrirFormularioNovoHistorico"
                                        :disabled="loadingHistorico"
                                        class="mr-2"
                                    >
                                        <v-icon small left>mdi-plus</v-icon>
                                        Adicionar
                                    </v-btn>
                                    <v-btn
                                        icon
                                        small
                                        @click="recarregarHistorico"
                                        :loading="loadingHistorico"
                                    >
                                        <v-icon>mdi-refresh</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-card-text>
                                    <v-data-table
                                        :headers="headersHistorico"
                                        :items="historicoStatus"
                                        :loading="loadingHistorico"
                                        hide-default-footer
                                        :items-per-page="-1"
                                        class="elevation-0"
                                    >
                                        <template
                                            v-slot:[`item.data`]="{ item }"
                                        >
                                            {{ formatarDataHoraDB(item.data) }}
                                        </template>
                                        <template
                                            v-slot:[`item.status`]="{ item }"
                                        >
                                            <v-chip
                                                :color="
                                                    getStatusColor(item.status)
                                                "
                                                text-color="white"
                                                small
                                            >
                                                {{ item.status }}
                                            </v-chip>
                                        </template>
                                        <template
                                            v-slot:[`item.acoes`]="{ item }"
                                        >
                                            <v-tooltip top>
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs
                                                    }"
                                                >
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        icon
                                                        small
                                                        color="error"
                                                        @click="
                                                            abrirConfirmacaoDeleteHistorico(
                                                                item
                                                            )
                                                        "
                                                        :disabled="
                                                            loadingDeleteHistorico
                                                        "
                                                    >
                                                        <v-icon
                                                            >mdi-trash-can-outline</v-icon
                                                        >
                                                    </v-btn>
                                                </template>
                                                <span>Excluir histórico</span>
                                            </v-tooltip>
                                        </template>
                                    </v-data-table>

                                    <div
                                        v-if="
                                            historicoStatus.length === 0 &&
                                                !loadingHistorico
                                        "
                                        class="text-center grey--text pa-4"
                                    >
                                        Nenhum histórico de status encontrado
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="pa-6">
                    <v-btn
                        color="success"
                        @click="reprocessarRetorno"
                        :loading="loading"
                        :disabled="loading"
                    >
                        <v-icon left>mdi-refresh</v-icon>
                        Reprocessar retorno
                    </v-btn>
                    <v-btn
                        color="warning"
                        @click="ignorarRetorno"
                        :loading="loading"
                        :disabled="loading"
                    >
                        <v-icon left>mdi-eye-off</v-icon>
                        Ignorar Retorno
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="grey"
                        text
                        @click="fecharModal"
                        :disabled="loading"
                    >
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogNovoHistorico" max-width="600px" persistent>
            <v-card>
                <v-card-title class="primary white--text">
                    <v-icon left color="white">mdi-plus-circle</v-icon>
                    Adicionar Novo Histórico
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="fecharFormularioHistorico">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-6">
                    <v-form ref="formHistorico" v-model="formHistoricoValido">
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="novoHistorico.status"
                                    label="Status *"
                                    outlined
                                    dense
                                    :rules="[
                                        v => !!v || 'Status é obrigatório'
                                    ]"
                                    required
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="novoHistorico.data"
                                    label="Data/Hora *"
                                    outlined
                                    dense
                                    type="datetime-local"
                                    :rules="[
                                        v => !!v || 'Data/Hora é obrigatória'
                                    ]"
                                    required
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-card-actions class="pa-6">
                    <v-btn
                        color="success"
                        @click="salvarNovoHistorico"
                        :loading="loadingSalvarHistorico"
                        :disabled="
                            !formHistoricoValido || loadingSalvarHistorico
                        "
                    >
                        <v-icon left>mdi-content-save</v-icon>
                        Salvar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="grey"
                        text
                        @click="fecharFormularioHistorico"
                        :disabled="loadingSalvarHistorico"
                    >
                        Cancelar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogConfirmDeleteHistorico" max-width="550">
            <v-card max-width="550">
                <v-card-title class="headline primary--text">
                    Confirmação
                </v-card-title>
                <v-card-text>
                    Deseja realmente excluir o histórico?
                </v-card-text>
                <v-card-text v-if="historicoParaDeletar">
                    {{ formatarDataHora(historicoParaDeletar.data) }}:
                    {{ historicoParaDeletar.observacao }}
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        @click="fecharConfirmacaoDeleteHistorico"
                        :disabled="loadingDeleteHistorico"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        @click="confirmarDeleteHistorico"
                        :loading="loadingDeleteHistorico"
                        color="error"
                    >
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import FalhaRetornosService from '@/services/FalhaRetornosService';
import TituloService from '@/services/TituloService';
import Loading from 'vue-loading-overlay';
import moment from 'moment';

export default {
    name: 'ModalEdicaoFalhaRetorno',
    components: {
        Loading
    },
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        falhaRetorno: {
            type: Object,
            default: () => ({})
        },
        aguardandoReprocessamento: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            loadingHistorico: false,
            loadingSalvarHistorico: false,
            dadosEdicao: {},
            detalhesCompletos: {},
            historicoStatus: [],
            dialogNovoHistorico: false,
            formHistoricoValido: false,
            dialogConfirmDeleteHistorico: false,
            historicoParaDeletar: null,
            loadingDeleteHistorico: false,
            novoHistorico: {
                status: '',
                data: ''
            },
            headersHistorico: [
                { text: 'Data/Hora', value: 'data', sortable: true },
                { text: 'Status', value: 'status', sortable: false },
                { text: 'Observação', value: 'observacao', sortable: false },
                { text: 'Usuário', value: 'usuario', sortable: false },
                {
                    text: 'Ações',
                    value: 'acoes',
                    sortable: false,
                    width: '100px'
                }
            ]
        };
    },
    computed: {
        show: {
            get() {
                return this.showModal;
            },
            set(value) {
                if (!value) {
                    this.$emit('fecharModal');
                }
            }
        }
    },
    watch: {
        showModal: {
            immediate: true,
            handler(novoValor) {
                if (novoValor && this.falhaRetorno) {
                    this.inicializarDados();
                }
            }
        },
        falhaRetorno: {
            immediate: true,
            deep: true,
            handler(novoValor) {
                if (novoValor && this.showModal) {
                    this.inicializarDados();
                }
            }
        }
    },
    methods: {
        async inicializarDados() {
            this.dadosEdicao = { ...this.falhaRetorno };
            this.formatarDatasParaEdicao();
            await this.carregarDadosCompletos();
        },

        formatarDatasParaEdicao() {
            if (this.dadosEdicao.dt_apontamento) {
                this.dadosEdicao.dt_apontamento = this.formatarDataHora(
                    this.dadosEdicao.dt_apontamento
                );
            }
        },

        async carregarDadosCompletos() {
            try {
                this.loading = true;
                this.loadingHistorico = true;

                const tituloService = new TituloService(
                    this.$http,
                    this.$store
                );
                let params = {
                    id_titulo: this.falhaRetorno.id_titulo,
                    cd_apresentante: this.falhaRetorno.cd_apresentante
                };
                if (this.falhaRetorno.cd_comprador != null) {
                    params.cd_apresentante = this.falhaRetorno.cd_comprador;
                }
                const tituloResponse = await tituloService.detalharTituloView(
                    params
                );

                if (tituloResponse && tituloResponse.body) {
                    if (tituloResponse.body.detalhe_titulo) {
                        const titulo = tituloResponse.body.detalhe_titulo;

                        if (!this.dadosEdicao.protocolo_cartorio) {
                            this.dadosEdicao.protocolo_cartorio =
                                titulo.apontamento_nu_protocolo || '';
                        }
                        if (!this.dadosEdicao.cartorio) {
                            this.dadosEdicao.cartorio =
                                titulo.nm_cartorio_apontamento || '';
                        }
                        if (!this.dadosEdicao.endereco_cartorio) {
                            this.dadosEdicao.endereco_cartorio =
                                titulo.ds_endereco_completo_cartorio ||
                                titulo.ds_endereco_cartorio ||
                                '';
                        }
                        if (!this.dadosEdicao.municipio_apontamento) {
                            this.dadosEdicao.municipio_apontamento =
                                titulo.nm_municipio_apontamento ||
                                titulo.nm_cidade_cartorio ||
                                '';
                        }
                        if (!this.dadosEdicao.email_cartorio) {
                            this.dadosEdicao.email_cartorio =
                                titulo.email_cartorio || '';
                        }
                        if (!this.dadosEdicao.telefone_cartorio) {
                            this.dadosEdicao.telefone_cartorio =
                                titulo.telefone_cartorio || '';
                        }

                        this.detalhesCompletos = {
                            razao_social_apresentante:
                                titulo.nm_razao_social || ''
                        };
                    }

                    if (tituloResponse.body.historico_titulo) {
                        this.historicoStatus = tituloResponse.body.historico_titulo.map(
                            item => ({
                                id_historico: item.id_historico,
                                data: item.dt_historico,
                                status: item.ds_status,
                                observacao: item.DESCRICAO || '',
                                usuario:
                                    item.nm_user || item.ds_login || 'Sistema'
                            })
                        );
                    } else {
                        this.historicoStatus = [];
                    }
                }
            } catch (error) {
                console.error('Erro ao carregar dados completos:', error);
                this.$emit(
                    'mostrarMensagem',
                    'Erro ao carregar dados completos',
                    'error'
                );
                this.historicoStatus = [];
            } finally {
                this.loading = false;
                this.loadingHistorico = false;
            }
        },

        async recarregarHistorico() {
            await this.carregarDadosCompletos();
        },

        async reprocessarRetorno() {
            try {
                this.loading = true;
                const service = new FalhaRetornosService(
                    this.$http,
                    this.$store
                );

                const dadosCompletos = {
                    ...this.dadosEdicao,
                    id: this.falhaRetorno.id
                };

                await service.reprocessarRetornoComDados(dadosCompletos);
                this.$emit(
                    'mostrarMensagem',
                    'Dados salvos e retorno reprocessado com sucesso',
                    'success'
                );
                this.$emit('atualizarLista');
                this.fecharModal();
            } catch (error) {
                console.error('Erro ao reprocessar retorno:', error);
                this.$emit(
                    'mostrarMensagem',
                    'Erro ao reprocessar retorno',
                    'error'
                );
            } finally {
                this.loading = false;
            }
        },

        async ignorarRetorno() {
            try {
                this.loading = true;
                const service = new FalhaRetornosService(
                    this.$http,
                    this.$store
                );
                await service.ignorarRetorno(this.falhaRetorno.id);
                this.$emit(
                    'mostrarMensagem',
                    'Retorno ignorado com sucesso',
                    'success'
                );
                this.$emit('atualizarLista');
                this.fecharModal();
            } catch (error) {
                console.error('Erro ao ignorar retorno:', error);
                this.$emit(
                    'mostrarMensagem',
                    'Erro ao ignorar retorno',
                    'error'
                );
            } finally {
                this.loading = false;
            }
        },

        fecharModal() {
            this.$emit('fecharModal');
        },

        formatarDataHora(datas) {
            return moment(datas).format('DD/MM/YYYY');
        },

        formatarDataHoraDB(dataHistorico) {
            const [data, hora] = dataHistorico.split(' ');
            const [dia, mes, ano] = data.split('/');
            const dataFormatada = `${ano}-${mes}-${dia} ` + hora;

            return dataFormatada;
        },

        getStatusColor(status) {
            const colors = {
                pendente: 'orange',
                processado: 'green',
                reprocessado: 'blue',
                ignorado: 'grey',
                erro: 'red',
                cancelado: 'red darken-2'
            };
            return colors[status?.toLowerCase()] || 'grey';
        },

        abrirFormularioNovoHistorico() {
            this.novoHistorico = {
                status: '',
                observacao: '',
                data: this.formatarDataHora(new Date())
            };
            this.dialogNovoHistorico = true;
            this.$nextTick(() => {
                if (this.$refs.formHistorico) {
                    this.$refs.formHistorico.resetValidation();
                }
            });
        },

        fecharFormularioHistorico() {
            this.dialogNovoHistorico = false;
            this.novoHistorico = {
                status: '',
                observacao: '',
                data: ''
            };
            if (this.$refs.formHistorico) {
                this.$refs.formHistorico.resetValidation();
            }
        },

        async salvarNovoHistorico() {
            if (!this.$refs.formHistorico.validate()) {
                return;
            }

            try {
                this.loadingSalvarHistorico = true;
                const service = new FalhaRetornosService(
                    this.$http,
                    this.$store
                );

                const dadosHistorico = {
                    id_titulo: this.falhaRetorno.id_titulo,
                    cd_apresentante: this.falhaRetorno.cd_apresentante,
                    status: this.novoHistorico.status,
                    observacao: this.novoHistorico.observacao,
                    data: this.novoHistorico.data
                };

                await service.adicionarHistoricoStatus(dadosHistorico);
                this.$emit(
                    'mostrarMensagem',
                    'Histórico adicionado com sucesso',
                    'success'
                );
                this.fecharFormularioHistorico();
                await this.recarregarHistorico();
            } catch (error) {
                console.error('Erro ao adicionar histórico:', error);
                this.$emit(
                    'mostrarMensagem',
                    'Erro ao adicionar histórico',
                    'error'
                );
            } finally {
                this.loadingSalvarHistorico = false;
            }
        },

        abrirConfirmacaoDeleteHistorico(historico) {
            this.historicoParaDeletar = historico;
            this.dialogConfirmDeleteHistorico = true;
        },

        fecharConfirmacaoDeleteHistorico() {
            this.dialogConfirmDeleteHistorico = false;
            this.historicoParaDeletar = null;
        },

        async confirmarDeleteHistorico() {
            if (
                !this.historicoParaDeletar ||
                !this.historicoParaDeletar.id_historico
            ) {
                this.$emit(
                    'mostrarMensagem',
                    'Erro: ID do histórico não encontrado',
                    'error'
                );
                return;
            }

            try {
                this.loadingDeleteHistorico = true;
                const tituloService = new TituloService(
                    this.$http,
                    this.$store
                );

                await tituloService.deleteHistoryStatus(
                    this.historicoParaDeletar.id_historico
                );

                this.$emit(
                    'mostrarMensagem',
                    'Histórico excluído com sucesso!',
                    'success'
                );
                this.fecharConfirmacaoDeleteHistorico();
                await this.recarregarHistorico();
            } catch (error) {
                console.error('Erro ao excluir histórico:', error);
                this.$emit(
                    'mostrarMensagem',
                    'Erro ao excluir histórico!',
                    'error'
                );
            } finally {
                this.loadingDeleteHistorico = false;
            }
        }
    }
};
</script>

<style scoped>
.v-card-title {
    font-weight: 600;
}

.v-card >>> .v-data-table {
    font-size: 0.875rem;
}

.v-dialog > .v-card > .v-card-text {
    max-height: 80vh;
    overflow-y: auto;
}

/* Estilo para campos somente leitura */
.readonly-field >>> .v-input__control {
    opacity: 0.6;
}

.readonly-field >>> .v-text-field__details {
    opacity: 0.6;
}

.readonly-field >>> input,
.readonly-field >>> textarea {
    color: #666 !important;
    background-color: #f5f5f5 !important;
    cursor: not-allowed !important;
}

.readonly-field >>> .v-input__slot {
    background-color: #f5f5f5 !important;
}

.readonly-field >>> .v-text-field--outlined fieldset {
    border-color: #ddd !important;
}

.readonly-field
    >>> .v-text-field--outlined:not(.v-input--is-focused):not(.v-text-field--filled)
    .v-text-field__slot:hover
    fieldset {
    border-color: #ddd !important;
}

/* Estilo para campos editáveis - destaque visual */
.editable-field >>> .v-text-field--outlined fieldset {
    border-color: #1976d2 !important;
    border-width: 2px !important;
}

.editable-field
    >>> .v-text-field--outlined:not(.v-input--is-focused):not(.v-text-field--filled)
    .v-text-field__slot:hover
    fieldset {
    border-color: #1565c0 !important;
}

.editable-field >>> .v-input__slot {
    background-color: #ffffff !important;
}

/* Estilo para labels dos campos readonly */
.readonly-field >>> .v-label {
    color: #666 !important;
    font-weight: normal !important;
}
</style>
